import { CREDIT_SELECTION_ABC_EXPERIMENT_IDS, FORM_FIELDS, PAGE, UTM_MARKS } from '../../../../constants';
import { EMPLOYMENT_TYPE_SOURCE, AREA_OF_EMPLOYMENT_SOURCE, JOB_TYPE_SOURCE } from '../../../../constants/sources';
import analytics from '../../../../helpers/analytics';
import { postMessage, PostMessageType } from '../../../../helpers/whitelable';
import { sourceNameByValue } from '../../../../helpers';
import { checkAbExperimentVariant } from '../../../../helpers/experiments';
import { getStore } from '../../../../store/client';
import { extendFormData, extendFormStore } from '../../../../store/reducers/formStore';
import { api } from '../../../../helpers/client';
import { checkAbAdditionalQuestions } from '../../../../helpers/experiments/additional.questions';
import { marksSelector } from '../../../../store/reducers/utmMarks';
import { organizationDataToForm, sendFullDataPostMessage } from './helpers';

export { WorkStepView } from './view';
export { schema } from './schema';

export const onNext = async () => {
    const { page, edit, formData, autoRun } = getStore().getState().formStore;
    const { experiments } = getStore().getState().abData;
    const marks = getStore().getState().utmMarks;
    const { [UTM_MARKS.MEDIUM]: utmMedium } = marksSelector(marks);
    const isShowFocusedView = checkAbExperimentVariant(
        experiments,
        page,
        utmMedium,
        CREDIT_SELECTION_ABC_EXPERIMENT_IDS.NEW_FOCUSED_FORM,
        '1',
    );

    const isShowAdditionalQuestions = checkAbAdditionalQuestions('1');

    if ([PAGE.WHITELABEL, PAGE.WAYBACK].includes(page as any)) {
        postMessage({
            type: PostMessageType.framePageCompleted,
            result: {
                page_number: 3,
            },
        });
    }

    if (page == PAGE.AVITO) {
        postMessage({
            type: PostMessageType.event,
            label: 'broker_form_work_submit',
        });
    }

    const {
        [FORM_FIELDS.EMPLOYER_INN]: employerInn,
        [FORM_FIELDS.AREA_OF_EMPLOYMENT]: areaOfEmployment,
        [FORM_FIELDS.EMPLOYER_TYPE]: employerType,
        [FORM_FIELDS.ORGANIZATION_NAME]: organizationName,
        [FORM_FIELDS.OKVED]: okved,
    } = formData;

    /** Временное решение. Убрать после того, как из ProfileService будут приходить данные о работодателе */
    if ((!areaOfEmployment || !employerType || !okved) && employerInn && organizationName) {
        const data = await api.organizationByInn(employerInn);

        if (data) {
            const dataToUpdate = organizationDataToForm(data);
            getStore().dispatch(extendFormData(dataToUpdate));
        }
    }

    const employmentType = sourceNameByValue(formData[FORM_FIELDS.EMPLOYMENT_TYPE], EMPLOYMENT_TYPE_SOURCE);
    const employmentArea = sourceNameByValue(formData[FORM_FIELDS.AREA_OF_EMPLOYMENT], AREA_OF_EMPLOYMENT_SOURCE);
    const jobType = sourceNameByValue(formData[FORM_FIELDS.JOB_TYPE], JOB_TYPE_SOURCE);
    const fillType = autoRun ? 'Проброс' : 'Ручное';
    analytics.emit({
        event: analytics.events.mainEvent,
        eventCategory: [PAGE.CARDS_RESTORE].includes(page as any)
            ? analytics.categories.CreditCard
            : analytics.categories.Loan,
        eventAction: isShowFocusedView ? 'Шаг 4|Доп. информация' : 'Шаг 3|Место работы',
        eventLabel: [
            fillType,
            `Тип занятости - ${employmentType}`,
            `Сфера деятельности - ${employmentArea}`,
            `Тип должности - ${jobType}`,
            ...(isShowAdditionalQuestions
                ? [`Подавали заявку на кредит в течение месяца - ${formData[FORM_FIELDS.HAS_RECENT_APPLICATION]}`]
                : []),
            ...(formData[FORM_FIELDS.RECENT_APPLICATION_CAUSE]
                ? [`Причина - ${formData[FORM_FIELDS.RECENT_APPLICATION_CAUSE]}`]
                : []),
        ].join('|'),
    });

    if (edit) {
        getStore().dispatch(extendFormStore({ edit: false }));
        return false;
    }

    if ([PAGE.WHITELABEL, PAGE.WAYBACK].includes(page as any)) {
        postMessage({
            type: PostMessageType.framePageCompleted,
            result: {
                page_number: 3,
            },
        });
    }

    if (page === PAGE.AVITO) {
        sendFullDataPostMessage();
    }

    return page !== PAGE.AVITO;
};
